export default "{\n    \"emptyStateLabel\": \"No Results Found\"\n}\n"